import React, { Fragment, useState } from 'react';
import { Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/20/solid';
import { resolveValue } from '../@types/types';
import { ToastIcon } from './toast-icon';
import { Toast } from '../@types/types';

const notification = React.memo(({ toast }: { toast: Toast }) => {
  const [show, setShow] = useState(true);

  const icon = <ToastIcon toast={toast} />;
  const message = resolveValue(toast.message, toast);
  const subTitle = resolveValue(toast.subTitle, toast);
  return (
    <>
      <div
        // aria-live="assertive"
        className={`${
          toast.visible ? 'animate-enter' : 'animate-leave'
        } max-w-md w-full  flex`}
      >
        <div className="w-full flex flex-col items-center space-y-4 sm:items-end">
          {/* Notification panel, dynamically insert this into the live region when it needs to be displayed */}
          <Transition
            show={show}
            as={Fragment}
            enter="transform ease-out duration-300 transition"
            enterFrom="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
            enterTo="translate-y-0 opacity-100 sm:translate-x-0"
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="max-w-sm w-full bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden">
              <div className="p-4">
                <div className="flex items-start">
                  <div className="flex-shrink-0">{icon}</div>
                  <div className="ml-3 w-0 flex-1 pt-0.5">
                    <p className="text-sm font-medium text-gray-900">
                      {message}
                    </p>
                    <p className="mt-1 text-sm text-gray-500">{subTitle}</p>
                  </div>
                  <div className="ml-4 flex-shrink-0 flex">
                    <button
                      // onClick={() => toast.dismiss(toast.id)}
                      onClick={() => {
                        setShow(false);
                      }}
                      className=" bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500"
                    >
                      <span className="sr-only">Close</span>
                      <XMarkIcon className="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </Transition>
        </div>
      </div>
    </>
  );
});

export default notification;
